module.exports = __webpack_public_path__ + "static/media/storms-02.d1c524b8.png";